import script from "./ReviewTeamLead.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewTeamLead.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__